(() => {
  const selector = '.kl-teaser-RsBW3u';
  const key = 'alisened-signup-dismissed-RsBW3u';
  const page = document.documentElement;
  const script = document.querySelector('script[data-als-signup]');
  const label = script?.dataset.closeLabel || 'Close sign up button';
  let dismissed = false;
  try { dismissed = sessionStorage.getItem(key) === '1'; } catch (_) {}
  if (dismissed) page.setAttribute('data-als-signup-dismissed', '');
  const attach = () => {
    document.querySelectorAll(selector).forEach(root => {
      const text = root.querySelector('[id^="rich-text-"] span');
      if (text && text.textContent !== 'Get 10% Off') text.textContent = 'Get 10% Off';
      root.querySelector('[role="button"]')?.setAttribute('aria-label', 'Get 10% Off');
      if (root.querySelector('.als-signup-close')) return;
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'als-signup-close';
      close.setAttribute('aria-label', label);
      close.textContent = '×';
      close.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        dismissed = true;
        page.setAttribute('data-als-signup-dismissed', '');
        try { sessionStorage.setItem(key, '1'); } catch (_) {}
      });
      root.append(close);
    });
  };
  attach();
  const observer = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches?.(selector) || node.querySelector?.(selector) || node.closest?.(selector))
    ))) attach();
  });
  observer.observe(document.body, {childList:true,subtree:true});
})();